import { Navigate, useParams } from 'react-router-dom'
import useResident from 'hooks/useResident'
import ProfessionalContactForm from '../forms/ProfessionalContactForm'

const ProfessionalContactCreateScreen = () => {
  const { id } = useParams()

  if (!id) {
    return <Navigate to="/residents" />
  }
  const { isLoading, resident, updateResident } = useResident({ id })

  return (
    <ProfessionalContactForm
      editedIndex={undefined}
      onSubmit={updateResident}
      isLoading={isLoading}
      resident={resident}
    />
  )
}

export default ProfessionalContactCreateScreen
